var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from 'react';
import Player, { Ratio } from './Player';
import Controls from './Controls';
import { FloatVideoContainer, FullscreenWrap } from './style';
export { resolveTotalTime, resolveSeekPosition, resolveOverallTime } from './lib';
var VideoPlayer = function (props, ref) {
    var isDebug = props.isDebug, isPlaying = props.isPlaying, volume = props.volume, src = props.src, fileType = props.fileType, start = props.start, playTime = props.playTime, onTimeUpdate = props.onTimeUpdate, currentTime = props.currentTime, totalTime = props.totalTime, onPlayChange = props.onPlayChange, onSeek = props.onSeek, setIsFullPage = props.setIsFullPage, setVolume = props.setVolume, isFullPage = props.isFullPage, isEnded = props.isEnded, handleRePlay = props.handleRePlay;
    var _a = useState(playTime), prevPlayTime = _a[0], setPrevPlayTime = _a[1];
    var _b = useState(start), playerTime = _b[0], setPlayerTime = _b[1];
    var wrapper = useRef(null);
    var fullscreen = function () {
        if (!wrapper.current)
            return;
        if (!document.fullscreenElement) {
            wrapper.current.requestFullscreen().catch(function (err) {
                console.error("Error attempting to enable full-screen mode: ".concat(err.message, " (").concat(err.name, ")"));
            });
        }
        else {
            document.exitFullscreen();
        }
    };
    useEffect(function () {
        if (playTime > 0 && prevPlayTime !== playTime) {
            setPrevPlayTime(playTime);
            setPlayerTime(playTime);
        }
        else {
            setPlayerTime(start);
        }
    }, [start, playTime]);
    return (_jsx(_Fragment, { children: _jsx(FullscreenWrap, __assign({ ref: wrapper }, { children: _jsx(FloatVideoContainer, __assign({ float: false, top: 3 }, { children: _jsxs(Ratio, __assign({ width: 16, height: 9 }, { children: [_jsx("div", __assign({ style: {
                                height: '100%',
                                position: 'relative',
                                background: 'rgba(0,0,0,0.85)'
                            } }, { children: _jsx(Player, { ref: ref, isDebug: isDebug, isPlaying: isPlaying, src: src, fileType: fileType, volume: volume, time: playerTime, onPlayerTimeUpdate: onTimeUpdate, isEnded: isEnded }) })), _jsx("div", __assign({ style: {
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0
                            } }, { children: _jsx(Controls, { disabled: false, isPlaying: isPlaying, currentTime: currentTime, totalTime: totalTime, onPlayChange: onPlayChange, onSeek: onSeek, onFullscreenChange: fullscreen, volume: volume, onVolumeChange: function (newVolume) {
                                    setVolume(newVolume);
                                }, isEnded: isEnded, handleRePlay: handleRePlay }) }))] })) })) })) }));
};
var VideoPlayerFR = React.forwardRef(VideoPlayer);
export { VideoPlayerFR as VideoPlayer };
//# sourceMappingURL=index.js.map